import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, CardContent, Typography, Grid, Avatar, Box, Button, Paper } from '@mui/material';
import { MailOutlined, PhoneOutlined, CalendarOutlined, CaretLeftOutlined } from '@ant-design/icons';

const CoachDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const coach = location.state?.coach;

  if (!coach) {
    return (
      <Box p={4}>
        <Typography variant="h6" color="error" gutterBottom>
          No coach data available.
        </Typography>
        <Button variant="outlined" startIcon={<CaretLeftOutlined style={{ fontSize: 18 }} />} onClick={() => navigate(-1)}>
          Back
        </Button>
      </Box>
    );
  }

  return (
    <Box p={4}>
      <Button variant="outlined" startIcon={<CaretLeftOutlined style={{ fontSize: 18 }} />} onClick={() => navigate(-1)} sx={{ mb: 3 }}>
        Back
      </Button>

      <Card elevation={4} sx={{ borderRadius: 3 }}>
        <CardContent>
          <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems="center" mb={3}>
            <Avatar
              alt={coach.coachName}
              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(coach.coachName)}`}
              sx={{ width: 100, height: 100, mr: { sm: 4 }, mb: { xs: 2, sm: 0 } }}
            />
            <Box>
              <Typography variant="h5" fontWeight={600}>
                {coach.coachName}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Coach ID: {coach.coachId}
              </Typography>
            </Box>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Paper elevation={2} sx={paperStyle}>
                <Avatar sx={{ bgcolor: '#1976d2', width: 40, height: 40 }}>
                  <MailOutlined style={{ fontSize: 20, color: '#fff' }} />
                </Avatar>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Email
                  </Typography>
                  <Typography variant="body1">{coach.coachEmail || 'N/A'}</Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <Paper elevation={2} sx={paperStyle}>
                <Avatar sx={{ bgcolor: '#2e7d32', width: 40, height: 40 }}>
                  <PhoneOutlined style={{ fontSize: 20, color: '#fff' }} />
                </Avatar>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Contact
                  </Typography>
                  <Typography variant="body1">{coach.coachContact || 'N/A'}</Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <Paper elevation={2} sx={paperStyle}>
                <Avatar sx={{ bgcolor: '#ed6c02', width: 40, height: 40 }}>
                  <CalendarOutlined style={{ fontSize: 20, color: '#fff' }} />
                </Avatar>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Joined Date
                  </Typography>
                  <Typography variant="body1">
                    {coach.registrationDate ? new Date(coach.registrationDate).toLocaleDateString() : 'N/A'}
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <Paper elevation={2} sx={paperStyle}>
                <Avatar sx={{ bgcolor: '#9c27b0', width: 40, height: 40 }}>👨‍🎓</Avatar>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Students Assigned
                  </Typography>
                  <Typography variant="body1">{coach.studentsCount ?? '0'}</Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

const paperStyle = {
  p: 2,
  borderRadius: 2,
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  transition: '0.3s',
  '&:hover': {
    boxShadow: 4
  }
};

export default CoachDetails;
